import { createFileRoute } from "@tanstack/react-router";
import * as React from "react";

export const Route = createFileRoute("/story")({
	component: StoryPage,
});

function StoryPage() {
	const timelineEvents = [
		{
			year: "11.11.2016",
			title: "První setkání",
			image: null,
			description:
				"Poprvé jsme se setkali na Žižkovské věži během salsa tančírny a následně spolu začali tančit a jezdit na výlety.",
		},
		{
			year: "15.5.2017",
			title: "Jsme spolu",
			image: "/images/story/spolu.jpg",
			description:
				"Od května 2017 tvoříme pár. Následně jsme se rozhodli cestovat a poznávat svět.",
		},
		{
			year: "26.6.2017",
			title: "Itálie",
			description:
				'První společná zahraniční cesta "nadivoko" do Itálie. Učíme se bydlet v autě, spíme pod širákem, stanujeme kde se dá, vaříme si v rendlíku na plynovém vařiči. Odvážíme si nespočet zážitků, nových poznatků a hlavně návykový pocit svobody a štěstí.',
			image: "/images/story/italie.jpg",
		},
		{
			year: "6.2.2018",
			title: "Mauricius",
			description:
				"První společná exotická dovolená na Mauriciu. Vysněné místo, které nám přineslo mnoho nových zážitků, poznatků, místních přátel a také zkušeností.",
			image: "/images/story/mauricius.jpg",
		},
		{
			year: "1.7.2018 - 20.10.2018",
			title: "Francie",
			description:
				"Dva měsíce práce na hotelu ve Francii uprostřed nádherných Alp nás pořádně zocelily jak fyzicky, tak psychicky. Poté jsme se vydali na dobrodružnou cestu po Monaku, Côte d'Azur, Andoře, Lucembursku a Švýcarsku.",
			image: "/images/story/francie.jpg",
		},
		{
			year: "20.9.2019 - 20.12.2019",
			title: "Jihovýchodní Asie",
			description:
				"Po úspěšném ukončení studií, jsme se vydali na tři měsíce cestování po Vietnamu, Indonésii a Thajsku jen s batohy na zádech. Tady jsme prožili jedno z našich největších dobrodružství, když jsme si v Hanoji koupili motorku a bez zkušeností jsme na ni projeli celý severní Vietnam. Jako zázrakem se nám nic nestalo.",
			image: "/images/story/vietnam.jpg",
		},
		{
			year: "6.7.2021 - 31.8.2021",
			title: "Fuerteventura",
			description:
				"První zkušenost s housesittingem na ostrově Fuerteventura. Začínáme cestovat luxusně a zadarmo.",
			image: "/images/story/housesitting.jpg",
		},
		{
			year: "4.12.2021 - 1.7.2022",
			title: "Amerika",
			description:
				"Sedm měsíců cestování po Karibiku (Britské a Americké Panenské ostrovy, Portoriko, Dominikánská republika), Jižní Americe (Ekvádor včetně Galapág) a Floridě. Únik před Covidem a evropskou zimou.",
			image: "/images/story/amerika.jpg",
		},
		{
			year: "31.8.2022 - 14.9.2024",
			title: "Nový Zéland a Oceánie",
			description:
				"Working holiday na Novém Zélandu, cestování po ostrovech Pacifiku (Samoa, Cookovy ostrovy, Havaj, Francouzská Polynésie), národních parcích západního pobřeží USA, Austrálii a Japonsku. Odjeli jsme původně jen na Nový Zéland na pár měsíců a nakonec z toho byly 2 roky cestování. Tahle cesta byla tím nejlepším, co jsme doposud spolu mohli podniknout. Tady jsme zažili ty pravé pocity svobody, možnost žít ze dne na den, na nic se nevázat, užívat si dny naplno a hlavně nemít žádný konečný termín odletové letenky. Cesta se postupně vyvíjela a my s ní. Jsme nesmírně vděční za to, co jsme mohli zažít, poznat, co jsme se naučili a za ten nespočet lidí, kteří nás inspirovali a za ty zážitky, za ta nesmírně krásná místa, která jsme mohli navštívit.",
			image: "/images/story/australie.jpg",
		},
		{
			year: "15.3.2024 14:14",
			title: "Žádost o ruku",
			description:
				"Na kopci Lykavittos v Athénách padla ta nejdůležitější otázka.",
			image: "/images/story/zadost.jpg",
		},
		{
			year: "2.8.2025",
			title: "Svatební den",
			description: (
				<>
					Nejkrásnější den našeho života.
					<br />
					Za těch 8 let jsme toho spolu zažili a viděli opravdu hodně a téměř se
					nezastavili. Náš život byl rozlítaný, ale to nás na něm právě bavilo.
					Teď nastal čas na další etapu, která přinese nejspíš mnoho nového, ale
					doufáme, že stále bude čas na to, co nás nejvíc baví a spojuje. Pojďte
					s námi oslavit tento nádherný okamžik!
				</>
			),
			image: null,
		},
	];

	return (
		<div className="container mx-auto px-4 py-8">
			<h2 className="text-4xl md:text-5xl font-serif text-[#7D9F7D] mb-12 md:mb-16 text-center">
				Náš příběh
			</h2>
			<div className="max-w-3xl mx-auto">
				{timelineEvents.map((event, index) => (
					<div key={event.year} className="relative mb-8">
						{/* Časová osa - vertikální čára */}
						<div className="absolute left-1/2 transform -translate-x-1/2 h-full w-0.5 bg-[#C1E1C1]" />

						{/* Obsah události */}
						<div
							className={`relative flex items-center ${
								index === timelineEvents.length - 1 || index === 0
									? "flex-col"
									: index % 2 === 0
										? "flex-row"
										: "flex-row-reverse"
							}`}
						>
							{/* Textová část */}
							<div
								className={`${
									index === timelineEvents.length - 1 || index === 0
										? "w-full text-center mb-4"
										: `w-1/2 ${index % 2 === 0 ? "pr-4 text-right" : "pl-4"}`
								}`}
							>
								<div className="bg-white p-4 rounded-lg shadow">
									<h3 className="text-lg font-light text-[#7D9F7D] mb-1">
										{event.year}
									</h3>
									<h4 className="text-lg font-medium mb-1">{event.title}</h4>
									<p className="text-sm text-gray-600">{event.description}</p>
								</div>
							</div>

							{/* Obrázek - zobrazí se pouze pokud existuje */}
							{event.image && (
								<div
									className={`${index === timelineEvents.length - 1 ? "w-full" : "w-1/2"}`}
								>
									<div className="relative">
										<div className="absolute left-1/2 transform -translate-x-1/2 w-3 h-3 rounded-full bg-[#C1E1C1] border-2 border-white" />
										<img
											src={event.image}
											alt={event.title}
											className="w-full h-64 object-cover rounded-lg shadow"
										/>
									</div>
								</div>
							)}
						</div>
					</div>
				))}
				<div className="flex justify-center">
					<img
						src="/images/rings.png"
						alt="Propletené prstýnky"
						className="w-16 h-16 md:w-24 md:h-24 opacity-80 object-contain bg-transparent"
					/>
				</div>
			</div>
		</div>
	);
}
